import React from 'react';
import { connect } from 'react-redux';
import { isLessonEmpty } from 'selectors/editor';
import { ButtonGroup } from 'ui';
import AutoSaveIndicator from './AutoSaveIndicator';
import PublishButton from './PublishButton';
import PublishedDate from './PublishedDate';
import DiscardButton from './DiscardButton';
import PreviewButton from './PreviewButton';
import TemplateStatusToggleButton from './TemplateStatusToggleButton';
import TemplateSettingsButton from './TemplateSettingsButton';

const Header = ({
  overviewPath,
  hasCurrentSection,
  hasSectionsWithInvalidElements,
  publishedAt,
  lessonState,
  isTemplate,
}) => (
  <div className="Index-header fd-c ai-fs">
    <a href={overviewPath} className="c-brand-blue td-u fz-12">
      {isTemplate
        ? t('contents.library.title')
        : t('lessons.editor.lesson_overview')}
    </a>
    <h1 className="Index-title">
      {isTemplate ? t('templates.editor.name') : t('lessons.editor.name')}
    </h1>
    <div className="d-f jc-sb ai-c w-fill">
      <div className="c-gray-dark fs-i">
        {publishedAt && <PublishedDate date={publishedAt} />}
        <AutoSaveIndicator />
      </div>
      <div>
        <ButtonGroup>
          {lessonState === 'new_version_pending' && <DiscardButton />}
          {isTemplate && <TemplateSettingsButton />}
          <PreviewButton disabled={!hasCurrentSection} />
          {!isTemplate && (
            <PublishButton
              disabled={!hasCurrentSection || hasSectionsWithInvalidElements}
            />
          )}
          {isTemplate && <TemplateStatusToggleButton />}
        </ButtonGroup>
      </div>
    </div>
  </div>
);

const mapStateToProps = ({ editor }) => ({
  hasCurrentSection: !isLessonEmpty(editor),
  hasSectionsWithInvalidElements: editor.sectionsWithInvalidElements.length,
  overviewPath: editor.lesson_overview_path,
  publishedAt: editor.publishedAt,
  lessonState: editor.lesson_state,
  isTemplate: editor.isTemplate,
});

export default connect(mapStateToProps)(Header);
